import { schedularTherapistFilterAction } from './constant';

export const setTherapistFilterAction = (therapists: any, discipline: any) => {
  return {
    type: schedularTherapistFilterAction.SET_THERAPIST_FILTER_IN_SCHUDLAR,
    payload: { therapists, discipline },
  };
};

export const resetTherapistFilterAction = (discipline: string) => {
  return {
    type: schedularTherapistFilterAction.RESET_THERAPIST_FILTER_IN_SCHUDLAR,
    payload: { discipline },
  };
};

export const maintainTherapistFilterAction = (
  therapists: any,
  discipline: any,
  therapistId: any
) => {
  return {
    type: schedularTherapistFilterAction.MAINTAIN_THERAPIST_FILTER_REQUEST,
    payload: { therapists, discipline, therapistId },
  };
};

export const getAllMaintainedTherapistAction = (discipline: string, therapistId: any) => {
  return {
    type: schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_REQUEST,
    payload: { therapistId, discipline },
  };
};

export const resetAllMaintainedTherapistAction = () => {
  return {
    type: schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_RESET,
  };
};


export const getSplitTaskMinAction = (payload: any) => {
  return {
    type: schedularTherapistFilterAction.SPLIT_TASK_MIN_REQUEST,
    payload,
  };
};

export const resetSplitTaskMinAction = () => {
  return {
    type: schedularTherapistFilterAction.SPLIT_TASK_MIN_RESET,
  };
};

export const editSplitTaskMinAction = (payload: any) => {
  return {
    type: schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_REQUEST,
    payload,
  };
};

export const editResetSplitTaskMinAction = () => {
  return {
    type: schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_RESET,
  };
};

export const getSplitTaskAction = (payload: any) => {
  return {
    type: schedularTherapistFilterAction.GET_SPLIT_TASK_REQUEST,
    payload,
  };
};

export const resetGetSplitTaskAction = () => {
  return {
    type: schedularTherapistFilterAction.GET_SPLIT_TASK_RESET,
  };
};


export const deleteSplitTaskAction = (payload: any) => {
  return {
    type: schedularTherapistFilterAction.DELETE_SPLIT_TASK_REQUEST,
    payload,
  };
};

export const resetDeleteSplitTaskAction = () => {
  return {
    type: schedularTherapistFilterAction.DELETE_SPLIT_TASK_RESET,
  };
};
